import { loadingStore } from './store';
import { type FnReducer } from './types';

export type LoadingOrderState = {
    isOrderUpdating: boolean;
    isOrderSideUpdating: boolean;
};

export const initialLoadingOrderState = {
    isOrderUpdating: false,
    isOrderSideUpdating: false,
};

const startUpdateOrderReducer: FnReducer<LoadingOrderState> = (state) => {
    state.isOrderUpdating = true;
};

const endUpdateOrderReducer: FnReducer<LoadingOrderState> = (state) => {
    state.isOrderUpdating = false;
};

const startUpdateOrderSideReducer: FnReducer<LoadingOrderState> = (state) => {
    state.isOrderSideUpdating = true;
};

const endUpdateOrderSideReducer: FnReducer<LoadingOrderState> = (state) => {
    state.isOrderSideUpdating = false;
};

const loadingOrderSlice = loadingStore.createSlice({
    name: 'loadingOrder',
    initialState: initialLoadingOrderState,
    reducers: {
        startUpdateOrderReducer,
        endUpdateOrderReducer,
        startUpdateOrderSideReducer,
        endUpdateOrderSideReducer,
    },
});

export const [useLoadingOrder, getLoadingOrder] = loadingOrderSlice.createSelector((state) => {
    return {
        isOrderUpdating: state.isOrderUpdating,
        isOrderSideUpdating: state.isOrderSideUpdating,
    };
});

export const startUpdateOrder = loadingOrderSlice.startUpdateOrderReducer;
export const endUpdateOrder = loadingOrderSlice.endUpdateOrderReducer;
export const startUpdateOrderSide = loadingOrderSlice.startUpdateOrderSideReducer;
export const endUpdateOrderSide = loadingOrderSlice.endUpdateOrderSideReducer;
